/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsReplyTimes } from './WebApiModelsReplyTimes';
import {
    WebApiModelsReplyTimesFromJSON,
    WebApiModelsReplyTimesFromJSONTyped,
    WebApiModelsReplyTimesToJSON,
} from './WebApiModelsReplyTimes';

/**
 * A person in the household of a primary member, with the reply the person already has for the event.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto {
    /**
     * The member id.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto
     */
    memberId?: number;
    /**
     * Name from the member register.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto
     */
    name?: string | null;
    /**
     * True for the primary member, who signs up the household.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto
     */
    isSelf?: boolean;
    /**
     * The reply the person already has for the event, or 0.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto
     */
    replyId?: number;
    /**
     * The answers of the reply.
     * @type {Array<WebApiModelsReplyTimes>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto
     */
    replyTime?: Array<WebApiModelsReplyTimes> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto {
    return WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isSelf': !exists(json, 'isSelf') ? undefined : json['isSelf'],
        'replyId': !exists(json, 'replyId') ? undefined : json['replyId'],
        'replyTime': !exists(json, 'replyTime') ? undefined : (json['replyTime'] === null ? null : (json['replyTime'] as Array<any>).map(WebApiModelsReplyTimesFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'name': value.name,
        'isSelf': value.isSelf,
        'replyId': value.replyId,
        'replyTime': value.replyTime === undefined ? undefined : (value.replyTime === null ? null : (value.replyTime as Array<any>).map(WebApiModelsReplyTimesToJSON)),
    };
}

